module.exports = __webpack_public_path__ + "img/8A5B34_F3BD7C_DA9758_BE7E45-256px.4a00d7ed.png";